module.exports = "//static.hsappstatic.net/ContentComponents/static-2.68361/img/content-remix-post-publish/content-remix-fr.png"